module.exports = __webpack_public_path__ + "img/member_reservation_area3.e936c250.png";